<template>
  <div class="flex justify-start items-center space-x-1 font-medium text-default-text-dark text-xs">
    <button class="text-default-text-lighter hover:text-indigo-500 px-2 py-0.5 rounded-md"
      @click="emit('addCell', { cellType: 'code', index: index, metadata: { kernelId: store.kernelName } })">
      + Code
    </button>
    <button class="text-default-text-lighter hover:text-indigo-500 px-2 py-0.5 rounded-md"
      @click="emit('addCell', { cellType: 'markdown', index: index })">
      + Markdown
    </button>
    <Menu v-if="store.connections.length > 0" as="div" class="relative inline-block text-left">
      <div>
        <MenuButton
          class="text-default-text-lighter hover:text-indigo-500 px-2 py-0.5 rounded-md inline-flex items-center">
          + SQL
          <ChevronDownIcon class="ml-1 h-3 w-3" aria-hidden="true" />
        </MenuButton>
      </div>

      <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95"
        enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75"
        leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
        <MenuItems
          class="absolute left-0 z-10 mt-2 w-56 origin-top-left rounded-md bg-default-bg-light shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div v-if="store.connections.length === 0" class="py-1">
            <MenuItem v-slot="{ active }">
            <div :class="[
                  active ? 'bg-default-bg-lighter text-default-text-light' : 'text-default-text-lighter',
                  'block px-4 py-2 text-sm'
                ]">
              No connections available
            </div>
            </MenuItem>
          </div>
          <div v-else class="py-1">
            <MenuItem v-for="connection in store.connections" :key="connection.uuid" v-slot="{ active }">
            <button :class="[
                  active ? 'bg-default-bg-light text-default-text-light' : 'text-default-text-lighter',
                  'flex items-center w-full text-left px-4 py-2 text-sm'
                ]"
              @click="emit('addCell', { cellType: 'code', index: index, metadata: { kernelId: connection.uuid } })">
              <CircleStackIcon class="h-4 w-4 mr-2" />
              <span class="text-default-text-light text-sm">{{ connection.name }}</span>
            </button>
            </MenuItem>
          </div>
        </MenuItems>
      </transition>
    </Menu>
  </div>
</template>

<script setup>
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'
import { ChevronDownIcon, CircleStackIcon } from '@heroicons/vue/20/solid'

const props = defineProps({
  index: {
    type: Number,
    required: true,
  },
});
const emit = defineEmits(["addCell"]);

const store = useStore();
</script>
